const state = {
    documents: []
}

export default state
